import ClearIcon from '@mui/icons-material/Clear';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Button, type ButtonProps, Typography } from '@mui/material';
import cx from 'classnames';
import type React from 'react';
import styled from 'styled-components';

const HelpText = styled(Typography)`
  opacity: 0;
  transition: opacity 300ms;
  transition-delay: 0s;
  position: absolute;
  left: 0.75rem;
  line-height: 1.75;
`;

const CloseIcon = styled(ClearIcon)`
  position: absolute;
  right: 0.4rem;
`;

const HelpIcon = styled(HelpOutlineIcon)`
  position: absolute;
  right: 0.4rem;
`;

const HelpButtonContainer = styled(Button)`
  position: relative;
  background-color: ${({ theme }) => theme.palette.background.paper};
  transition: width 500ms;
  min-width: 0;
  width: ${({ theme }) => theme.spacing(4)};
  height:${({ theme }) => theme.spacing(4)};
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  overflow: hidden;

  &:hover,
  &.active {
    width: 5rem;

    ${HelpText} {
      opacity: 1;
      transition-delay: 300ms;
    }
  }
`;

export type HelpButtonProps = {
  readonly onToggle: (event: React.MouseEvent<HTMLButtonElement>) => void;
  readonly helpActive: boolean;
} & ButtonProps;

/** This displays an animated Help button, triggering its provided `onToggle` prop whenever clicked.
 *  The button has active and inactive styling, controlled with a CSS `.active` class and `:hover` state.
 */
export const HelpButton: React.FC<HelpButtonProps> = (props) => {
  const { onToggle, helpActive } = props;
  return (
    <HelpButtonContainer onClick={onToggle} className={cx({ active: helpActive })}>
      <HelpText variant="subtitle2">Help</HelpText>
      {helpActive ? <CloseIcon color="primary" /> : <HelpIcon color="primary" />}
    </HelpButtonContainer>
  );
};

export default HelpButton;
